var render = function (_h,_vm) {var _c=_vm._c;return _c('span',[_c('div',{staticClass:"con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to",staticStyle:{"height":"20px"}},[_c('span',{staticClass:"span-text-validation"},[_vm._v(_vm._s(_vm.props.error))])])])}
var staticRenderFns = []

export { render, staticRenderFns }